import styled from 'styled-components'
import * as BaseStyles from '../BaseStyles'

export const TeamMemberBoxDiv = styled(BaseStyles.Div)`
    box-shadow:
    0 0px 2px rgba(0, 0, 0, 0.022),
    0 0px 3px rgba(0, 0, 0, 0.031),
    0 0px 4px rgba(0, 0, 0, 0.039),
    0 0px 5px rgba(0, 0, 0, 0.048),
    0 0px 6px rgba(0, 0, 0, 0.07)
    ;
    width: 30rem;
    height: 36rem;
    color: black;
    border-radius: 1.5rem;
    background-color: white;
    padding: 1.5rem;
    margin: 0rem 0.5rem;
    display: inline-block;
`

export const TeamMemberBoxContentsDiv = styled(BaseStyles.Div)`
    height: 36rem;
    border-top: 0.001rem solid #E8E8E8;
    border-bottom: 0.001rem solid #E8E8E8;
`

export const TeamMemberTitleDiv = styled(BaseStyles.Div)`
    width: 100%;
    height: 20%;
    text-align: center;
    position: relative;
`

export const TeamMemberImageDiv = styled(BaseStyles.Div)`
    width: 100%;
    height: 40%;
    display: flex;
    text-align: center;
    position: relative;
`

export const TeamMemberNameDiv = styled(BaseStyles.Div)`
    width: 100%;
    height: 20%;
    display: flex;
    position: relative;
`

export const TeamMemberSocialsDiv = styled(BaseStyles.Div)`
    width: 100%;
    height: 20%;
    display: flex;
    white-space: nowrap;
    position: relative;
    border-top: 0.001rem solid #E8E8E8;
`

export const SocialsDiv = styled(BaseStyles.Div)`
    width: 25%;
    height: 100%;
    text-align: center;
    position: relative;
    &:hover{
        transform: scale(1.2);
    }
`

export const TeamMemberTitleText = styled.h2`
    margin: 0;
    padding: 0;
    color: black;
    font-size: 2.2rem;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
`

export const TeamMemberNameText = styled.h2`
    margin: 0;
    padding: 0;
    color: black;
    font-size: 2.2rem;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
`

export const SocialImage = styled.img`
    height: 42%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    align: center;
`

export const TeamMemberImage = styled.img`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    align: center;
    height: 95%;
`